import React from "react";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import FrequentlyAskQuestion from "../components/Homepage/FrequentlyAskQuestion/FrequentlyAskQuestion";
import ImageSection from "../components/Homepage/FrequentlyAskQuestion/ImageSection";
import Layout from "../components/Layout/Layout";
import TrainingHero from "../assets/TrainingHero.png";
import axios from "axios";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const FAQ = () => {
  const [faqData, setFaqData] = useState([]);

  const getFAQData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/faqs`)
      .then((response) => {
        setFaqData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getFAQData();
  }, []);

  return (
    <Layout>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <BannerHeroSection
          title="Frequently Asked Questions"
          subtitle="Find answers to common questions about our training programs and services"
          bannerImage={TrainingHero}
          height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
          className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
        />

        {/* FAQ Content Section */}
        <div className="bg-white py-16 lg:py-20">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
                {/* Left Side - FAQ Questions */}
                <div className="lg:w-2/3">
                  <FrequentlyAskQuestion source="faq" faqData={faqData} />
                </div>

                {/* Right Side - Got Questions Image Section */}
                <div className="lg:w-1/3">
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex justify-center items-center"
                  >
                    <ImageSection />
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FAQ;
